import { Chip } from "@mui/material";
import moment from "moment";
import { StyledDatesChips } from "../../../styled/dates";

export const dateChipWithStatus = (emptyDisplay, isDateTime, size = "medium") => ({ row, column }) => {
  const date = row.original[column.id];
  const diff = date ? moment(date).diff(Date.now(), "days") : null;
  return date ? (
    <Chip

      label={moment(date).format(isDateTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY")}
      sx={
        diff < -1 ? StyledDatesChips.errorChip : diff < 0 ? StyledDatesChips.warningChip : StyledDatesChips.successChip
      }
      size={size}
    />
  ) : (
    <>{emptyDisplay}</> // Retornamos un elemento vacío si no hay fecha
  );
}